import React, { PropTypes, Component } from "react";
import { inject, observer } from "mobx-react";
import {Form} from 'reactstrap';
import DataWrapper from "../../../principal/containers/DataWrapper";
import _ from 'lodash';
import qs from 'query-string';
import FluxoSolicitacaoETTStore from "../stores/FluxoSolicitacaoETTStore";
import ParametrosGeraisStore from "../../../administracao/stores/ParametrosGeraisStore";
import {Redirect} from "react-router-dom";
import {FormWithActions} from "../../../comum/components/FormWithActions";
import {DetalhamentoSolicitante} from "../../comum/components/DetalhamentoSolicitante";
import {DetalhamentoEmpregadosSubstituidos} from "../../comum/components/DetalhamentoEmpregadosSubstituidos";
import {DetalhamentoContato} from "../../comum/components/DetalhamentoContato";
import {DetalhamentoCargo} from "../../comum/components/DetalhamentoCargo";
import {DetalhamentoJustificativaExcecao} from "../../comum/components/DetalhamentoJustificativaExcecao";
import {DetalhamentoDebito} from "../../comum/components/DetalhamentoDebito";
import {DetalhamentoLocais} from "../../comum/components/DetalhamentoLocais";
import {DetalhamentoJustificativa} from "../../comum/components/DetalhamentoJustificativa";
import {DetalhamentoPrazos} from "../../comum/components/DetalhamentoPrazos";
import {DetalhamentoPerfil} from "../../comum/components/DetalhamentoPerfil";
import {DetalhamentoCPFDiferente} from "../../solicitacao_ett/components/DetalhamentoCPFDiferente";
import {DetalhamentoDadosMOT} from "../../solicitacao_ett/components/DetalhamentoDadosMOT";
import {DetalhamentoSalarioDiferente} from "../../solicitacao_ett/components/DetalhamentoSalarioDiferente";
import {DetalhamentoAlterarDataInicio} from "../components/DetalhamentoAlterarDataInicio";
import {DetalhamentoContratosAnterioresEValidacoes} from "../../comum/components/DetalhamentoContratosAnterioresEValidacoes";
import {DetalhamentoHistoricoFluxo } from "../../comum/components/DetalhamentoHistoricoFluxo";
import {DetalhamentoHistorico} from "../../comum/components/DetalhamentoHistorico";
import {DadosTerminoAntecipado} from "../../solicitacao_termino_antecipado/components/DadosTerminoAntecipado";
import {DetalhamentoIndicacoesEtt} from "../../comum/components/DetalhamentoIndicacoesEtt";
import {LoadingPanel} from "../../../comum/components/LoadingPanel";

@inject("store")
@DataWrapper
@observer
export class DetalhesSolicitacaoETT extends Component {
    constructor(props) {
        super(props);
        this.state = this.props.store.appStore;
        this.loginStore = this.props.store.loginStore;
        this.formStore = this.props.store.formStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.validacaoStore = this.props.store.validacaoStore;
        this.modalStore = this.props.store.modalStore;
        this.loadingPanelStore = this.props.store.loadingPanelStore;

        this.parametrosGeraisStore = new ParametrosGeraisStore();

        this.controller = new FluxoSolicitacaoETTStore(this.parametrosGeraisStore, this.loginStore, this.tituloPaginaStore, this.validacaoStore, this.modalStore, this.loadingPanelStore);

    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Contratação");

        const taskId = _.get(this.props, "match.params.taskIdBpm");
        const solicitacaoId = _.get(this.props, "match.params.solicitacaoId");
        const solicitacaoEttId = _.get(this.props, "match.params.solicitacaoEttId");

        const dados = taskId ? {id: taskId, tipo: "tarefa"} : {solicitacaoId: solicitacaoId, solicitacaoEttId: solicitacaoEttId, tipo: "solicitacao"};

        const rota = _.get(this.props, "match.path"); // rota de origm
        const queryParams = qs.parse(this.props.location.search);

        const idFluxo = queryParams.idFluxo;

        //if (idFluxo || rota === "/contratacao/tarefa/:taskIdBpm") {
            dados.isFluxoNovo = true;
            dados.idFluxo = idFluxo;
        //}

        this.controller.carregarLista(dados);
        this.parametrosGeraisStore.carregarLista();
    }

    static propTypes = {
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array,
            PropTypes.object,
        ])
    };

    render() {
        if (this.formStore.acaoEnviada || !this.controller.dadosOk) {
            return <Redirect to="/solicitacoes-pendentes" />;
        } else {
            return this.renderForm();
        }
    }

    renderForm() {
        const desabilitarValidacao = this.validacaoStore.desabilitarValidacao
        const exibeDetalhamentoHistorico = this.controller.exibeDetalhamentoHistorico;
        const exibeEvolucaoFluxo = this.controller.exibeEvolucaoFluxo;

        return (
            <div>
                <div className="form-wrapper">
                    <LoadingPanel>
                        <div className="content-panel panel-sm">
                            <Form className="panel-form">
                                <FormWithActions controller={this.controller} taskId={_.get(this.props, "match.params.taskIdBpm")} solicitacaoExcecao={this.controller.isSolicitacaoExcecao}
                                             tarefa={this.controller.nomeTarefa} fluxo={this.controller.nomeFluxo} possiveisAcoes={this.controller.possiveisAcoes}
                                             error={this.formStore.submitted && !this.modalStore.exibirModal.aberto && !this.validacaoStore.isValidForm}>
                                    {this.controller.exibeJustificativaExcecao &&
                                        <DetalhamentoJustificativaExcecao />
                                    }
                                    <DetalhamentoSolicitante />
                                    <DetalhamentoContato desabilitarValidacao={desabilitarValidacao} />
                                    <DetalhamentoLocais />
                                    {this.controller.exibeDebito &&
                                        <DetalhamentoDebito />
                                    }
                                    <DetalhamentoJustificativa />
                                    <DetalhamentoEmpregadosSubstituidos />
                                    <DetalhamentoPrazos desabilitarValidacao={desabilitarValidacao}/>
                                    {this.controller.exibeDetalhamentoTerminoAntecipado &&
                                    <DadosTerminoAntecipado />
                                    }
                                    <DetalhamentoCargo />
                                    <DetalhamentoPerfil />
                                    {this.controller.exibeIndicacaoSolicitacaoEtt &&
                                        <DetalhamentoIndicacoesEtt />
                                    }
                                    {this.controller.exibeDetalhamentoCPFDiferente &&
                                        <DetalhamentoCPFDiferente desabilitarValidacao={desabilitarValidacao} />
                                    }
                                    {this.controller.exibeDetalhamentoDadosMOT &&
                                        <DetalhamentoDadosMOT desabilitarValidacao={desabilitarValidacao} />
                                    }
                                    {this.controller.exibeDetalhamentoSalarioDiferente &&
                                        <DetalhamentoSalarioDiferente desabilitarValidacao={desabilitarValidacao} />
                                    }
                                    {this.controller.exibeDetalhamentoAlterarDataInicio &&
                                        <DetalhamentoAlterarDataInicio desabilitarValidacao={desabilitarValidacao}/>
                                    }
                                    { this.controller.exibeContratosAnterioresEValidacoes &&
                                        <DetalhamentoContratosAnterioresEValidacoes/>
                                    }
                                    {exibeDetalhamentoHistorico && (exibeEvolucaoFluxo 
                                        ? <DetalhamentoHistoricoFluxo /> 
                                        : <DetalhamentoHistorico />
                                        )
                                    }
                                </FormWithActions>
                            </Form>
                        </div>
                    </LoadingPanel>
                </div>
            </div>
        )
    }
}